import {
  dropdownMapping,
  fetchAllPostPromisedData,
  fetchAllPromisedData,
  fetchDeletePromisedData,
  httpPostCall
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

import { endpoint } from "views/pages/manage/common/constant";

export const getCashDashboard = async (reqObj) => {
  return await fetchAllPostPromisedData(
    endpoint.cashManagement.dashboard,
    reqObj
  );
};

export const getReceiptsByDeposit = async (reqObj) => {
  return await fetchAllPostPromisedData(
    endpoint.cashManagement.receipts,
    reqObj
  );
};

export const sendDepositForApproval = async (reqObj,state) => {
  return await httpPostCall(
    endpoint.cashManagement.cashDashboard.sendForApproval,
    reqObj,
    'post',
    true,
    { state }
  );
};

export const getDepositedSlips = async (filterReqObj) => {
  return await fetchAllPostPromisedData(
    endpoint.cashManagement.depositedSlips,
    filterReqObj
  );
};

export const getDepositFilterDropdowns = async () => {
  try {
    const resp = await Promise.all([
      dropdownMapping(
        endpoint.businessArea.getAllActive,
        "businessAreaDispValue",
        "id"
      ),
      dropdownMapping(endpoint.cashier.getAllActive, "cashierName", "id"),
      dropdownMapping(endpoint.bank.getAllActive, "bankName", "id"),
    ]);

    return {
      allActiveBu: resp[0],
      allCashiers: resp[1],
      allBanks: resp[2],
    };
  } catch (err) {
    console.error(err);
  }
};

export const createSendForApprovalReqObj = ({
  depositForm,
  totalAmount,
  selectedReceipts,
  bankDetails,
  businessAreaId,
  depositId,
  depositSlipId,
  cashierOffice
}) => {
  const academicCareerValue = selectedReceipts[0]?.academicCareerValue || null;
  debugger
  return {
    businessAreaValue: businessAreaId,
    depositSlipNumber: depositForm.depositSlipNo,
    cashierOffice: cashierOffice || businessAreaId,
    receiptIds: selectedReceipts.map((item) => item.id),
    remarks: " ",
    slipS3Key: depositForm.viewer.s3Key,
    bankName: bankDetails?.description,
    totalAmount: totalAmount,
    status: "",
    depositSlipId: depositSlipId||depositId,
    accountNumber: bankDetails?.bankAccount,
    academicCareerValue: academicCareerValue,
  };
};

const MOCK_DB_DATA = Array.from({ length: 145 }).map((_, i) => {
  const statusOptions = [
    "APPROVED",
    "IN_PROGRESS",
    "ACTION_NEEDED",
    "REJECTED",
    "NOT_DEPOSITED",
  ];
  const types = ["Cash", "EPMR", "Cheque", "Online"];
  const students = ["Rani", "Shlok", "Mitesh", "Rahul", "Anjali", "Vikram"];

  // Helper to generate a random date within the last year
  const randomDate = (start, end) => {
    return new Date(
      start.getTime() + Math.random() * (end.getTime() - start.getTime())
    ).toISOString();
  };

  return {
    id: `row-${i}`,
    bu: `JP${String((i % 5) + 1).padStart(3, "0")}`,
    type: types[i % 4],
    psid: `0001259${3900 + i}`,
    student: students[i % students.length],
    courseId: `700${700 + (i % 50)}`,
    courseName: `Advanced React Engineering - Batch ${i % 5}`, // Used in Tooltip
    term: 2320 + (i % 5),
    receiptNo: `097RCC/B2500${300 + i}`,
    receiptDate: randomDate(new Date(2024, 0, 1), new Date()),
    cashierId: `A12345-${i}`,
    updatedOn: randomDate(new Date(2025, 0, 1), new Date()),
    approvedOn:
      i % 3 === 0 ? randomDate(new Date(2025, 0, 1), new Date()) : null, // Some are null
    status: statusOptions[i % 5],
    amount: 10000 + i * 1250, // Numeric value for sorting
  };
});

/**
 * 2. MOCK API FUNCTION
 * Simulates a server call with latency, sorting, and pagination.
 * * @param {number} page - Current page number (1-based)
 * @param {number} pageSize - Number of items per page
 * @param {string} sortKey - The column key to sort by
 * @param {string} sortDir - 'asc' or 'desc'
 */
export const fetchDepositData = (
  page = 1,
  pageSize = 10,
  sortKey = null,
  sortDir = "asc"
) => {
  return new Promise((resolve) => {
    // Simulate network delay (500ms - 1.5s)
    const delay = Math.floor(Math.random() * 1000) + 500;

    setTimeout(() => {
      let processedData = [...MOCK_DB_DATA];

      // A. SERVER-SIDE SORTING
      if (sortKey) {
        processedData.sort((a, b) => {
          let valA = a[sortKey];
          let valB = b[sortKey];

          // Handle nulls
          if (valA === null) valA = "";
          if (valB === null) valB = "";

          // String comparison
          if (typeof valA === "string") {
            valA = valA.toLowerCase();
            valB = valB.toLowerCase();
          }

          if (valA < valB) return sortDir === "asc" ? -1 : 1;
          if (valA > valB) return sortDir === "asc" ? 1 : -1;
          return 0;
        });
      }

      // B. SERVER-SIDE PAGINATION (Slicing)
      const totalItems = processedData.length;
      const startIndex = (page - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const paginatedData = processedData.slice(startIndex, endIndex);

      // C. RETURN RESPONSE
      resolve({
        data: paginatedData,
        total: totalItems,
        page: page,
        totalPages: Math.ceil(totalItems / pageSize),
      });
    }, delay);
  });
};

export const getReceiptListApi = (
  requestPayload,
  businessAreaId,
  depositId,
  cashierOffice
) => {
  const { pageNo, pageSize } = requestPayload;
  const cashierOfficeInRequest = cashierOffice ? cashierOffice : businessAreaId;
  const request = {
    ...requestPayload,
    businessArea: businessAreaId,
    cashierOffice: cashierOfficeInRequest,
    status: ["NOT_DEPOSITED"],
    paymentMode :"CASH"
  };
  if (depositId) {
    request["depositId"] = depositId;
    request["status"] = [];
  }

  const url = `${endpoint.cashManagement.cashDashboard.receiptList}?offset=${pageNo}&pageSize=${pageSize}`;

  return httpPostCall(url, request, "POST");
};

export const getDepositedReceiptListApi = (
  requestPayload,
  businessAreaId,
  depositId,
  cashierOffice
) => {
  const { pageNo, pageSize } = requestPayload;
  const cashierOfficeInRequest = cashierOffice ? cashierOffice : businessAreaId;
  const request = {
    ...requestPayload,
    businessArea: businessAreaId,
    cashierOffice: cashierOfficeInRequest,
  };

  const url = `${endpoint.cashManagement.cashDashboard.receiptList}?offset=${pageNo}&pageSize=${pageSize}`;

  return httpPostCall(url, request, "POST");
};
